/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React from "react";

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import progressBar from '05Images/progressBar.svg';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ プログレスバー ------*/
const SdivProgressGroup = styled.div`
    user-select: none;
    z-index:80;
    position:fixed;
    width:100vw;
    height:100vh;
    bottom:0px;
    left:0;
`;
const SdivFilm = styled.div`
	position:fixed;//背景
    z-index:80;
    top:0;
	left:0;
    width:100vw;
    height:100vh;

`;
const Sdiv = styled.div`//プログレスバー枠
    position:fixed;
    z-index:80;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);

`;
const Simg = styled.img`
    
`;
/*====== Define global variables/functions ======*/
/*------ global variables ------*/
/*------ global functions ------*/

/*====================*/
/*======  Main  ======*/
/*====================*/
export const LoadingProgressBar = (props) => {
    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    const {open} = props; 

    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/  
	return (
        <>
            {open === true ?
            // <SdivProgressGroup tabindex="-1" aria-hidden="true" inert>
                <SdivProgressGroup>
                <SdivFilm >
                    <Sdiv >
                        <Simg src={progressBar} decording='async'/>
                    </Sdiv>
                </SdivFilm>
                </SdivProgressGroup>
            // </SdivProgressGroup>
            :<></>
            }
        </>
	);
};